import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import {
  AiOutlineDashboard,
  AiOutlineShoppingCart,
  AiOutlineUser,
} from "react-icons/ai";
import { RiCouponLine } from "react-icons/ri";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { ImBlog } from "react-icons/im";
import { IoIosNotifications } from "react-icons/io";
import { FaClipboardList, FaBloggerB, FaInstagram, FaCog, FaCamera, FaGlobe, FaChartLine } from "react-icons/fa";
import { BiBracket, BiCategoryAlt } from "react-icons/bi";
import { Layout, Menu, theme } from "antd";
import { useNavigate } from "react-router-dom";
import "../pages/style.css"
import axios from "axios";
import { FaSignOutAlt } from "react-icons/fa";


const { Header, Sider, Content } = Layout;


const MainLayout = () => {

  axios.defaults.withCredentials = true
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();
  return (
    <Layout>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ backgroundColor: "#6B3F4F" }} // Background color for the main sidebar
        collapsedWidth={80} // Adjusted collapsed width
      >
        <div className="logo" style={{ backgroundColor: "#6B3F4F" }}>
          <h2 className="text-white fs-5 text-center py-3 mb-0">
            <span className="sm-logo">GD</span>
            <span className="lg-logo">Gulabi Decor</span>
          </h2>
        </div>
        <Menu
          theme="dark"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {

            if (key === "signout") {
              // Handle signout logic here
            } else {
              navigate(key);
            }
          }}
          style={{
            backgroundColor: "#6B3F4F",

          }}
          items={[

            {
              key: "customers",
              icon: <AiOutlineUser className="fs-4" style={{ color: "#ffffff" }} />,
              label: <span style={{ color: "#ffffff" }}>Customers</span>,
            },

            {
              key: "Catalog",
              icon: <AiOutlineShoppingCart className="fs-4" style={{ color: "#ffffff" }} />,
              label: <span style={{ color: "#ffffff" }}>Catalog</span>,
              children: [
                {
                  key: "product",
                  icon: <AiOutlineShoppingCart className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Add Product</span>,
                },
                {
                  key: "list-product",
                  icon: <AiOutlineShoppingCart className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Product List</span>,
                },
                {
                  key: "category",
                  icon: <BiCategoryAlt className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Category</span>,
                },
                {
                  key: "list-category",
                  icon: <BiCategoryAlt className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Category List</span>,
                },
                {
                  key: "attributes",
                  icon: <BiBracket className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Attributes</span>,
                },
              ],
            },
            {
              key: "orders",
              icon: <FaClipboardList className="fs-4" style={{ color: "#ffffff" }} />,
              label: <span style={{ color: "#ffffff" }}>Orders</span>,
            },
            {
              key: "sales",
              icon: <FaChartLine className="fs-4" style={{ color: "#ffffff" }} />,
              label: <span style={{ color: "#ffffff" }}>Sales Analytics</span>,
            },
            {
              key: "marketing",
              icon: <RiCouponLine className="fs-4" style={{ color: "#ffffff" }} />,
              label: <span style={{ color: "#ffffff" }}>Marketing</span>,
              children: [
                {
                  key: "coupon",
                  icon: <ImBlog className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Add Coupon</span>,
                },
                {
                  key: "coupon-list",
                  icon: <RiCouponLine className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Coupon List</span>,
                },
              ],
            },
            {
              key: "blogs",
              icon: <FaBloggerB className="fs-4" style={{ color: "#ffffff" }} />,
              label: <span style={{ color: "#ffffff" }}>Blogs</span>,
              children: [
                {
                  key: "blog",
                  icon: <ImBlog className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Add Blog</span>,
                },
                {
                  key: "blog-list",
                  icon: <FaBloggerB className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Blog List</span>,
                },
                {
                  key: "blog-category",
                  icon: <ImBlog className="fs-4" style={{ color: "#ffffff" }} />,
                  label: <span style={{ color: "#ffffff" }}>Add Blog Category</span>,
                },

              ],
            },
            {
              key: "enquiries",
              icon: <FaClipboardList className="fs-4" style={{ color: "#ffffff" }} />,
              label: <span style={{ color: "#ffffff" }}>Enquiries</span>,
            },
            {
              key: "Signout",
              icon: <FaSignOutAlt className="fs-4" style={{ color: "#ffffff" }} />,
              label: (
                <span
                  style={{ color: "#ffffff", cursor: "pointer" }}
                  onClick={() => {
                    localStorage.removeItem("adminToken"); // Remove admin token
                    window.location.href = "/"; // Redirect to home page
                  }}
                >
                  Signout
                </span>
              ),
            },
          ]}
        />
        <hr style={{ color: "white" }}></hr>

        <Menu
          theme="dark"
          defaultSelectedKeys={[""]}
          onClick={({ key }) => {
            if (key === "signout") {
              // Handle signout logic here
            } else {
              navigate(key);
            }
          }}
          style={{
            backgroundColor: "#6B3F4F",

          }}
          items={[


          ]}
        />
      </Sider>

      <Layout className="site-layout">
        <Header
          className="d-flex justify-content-between ps-1 pe-5"
          style={{
            padding: 0,
            background: "#6B3F4F",
            color: "white",
          }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}
          <div className="d-flex gap-4 align-items-center" style={{ background: "F4DFB9" }}>

            <div className="d-flex gap-3 align-items-center dropdown">

              <div
                role="button"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <h5 className="mb-0">Gulabi Decor</h5>
                <p className="mb-0">info@gulabidecor.com</p>
              </div>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    View Profile
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item py-1 mb-1"
                    style={{ height: "auto", lineHeight: "20px" }}
                    to="/"
                  >
                    Signout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            background: colorBgContainer,
            backgroundColor: "#6B3F4F", // Ensure consistent background in content
          }}
        >
          <Outlet />
        </Content>
      </Layout>
      <ToastContainer />
    </Layout>
  );
};

export default MainLayout;
